import React, { useEffect, useState } from "react";
import { useUserContext } from "../../contexts/UserContext";
import Input from "../../components/form/Input";
import useFormHook from "../../hooks/useForm";
import Select from "../../components/form/Select";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import Button from "../../components/form/Button";
import dot from "dot-object";

const UPDATE_USER = gql`
  mutation UPDATE_USER(
    $id: uuid!
    $office: String!
    $firstName: String!
    $lastName: String!
    $phone: String!
    $street: String!
    $zip: String!
    $city: String!
    $country: String!
    $verified: Boolean!
  ) {
    update_user_by_pk(
      pk_columns: { id: $id }
      _set: {
        city: $city
        country: $country
        firstName: $firstName
        lastName: $lastName
        office: $office
        phone: $phone
        street: $street
        zip: $zip
        verified: $verified
      }
    ) {
      id
    }
  }
`;

export default function CustomerDataSettings(props) {
  const { userData, refetch } = useUserContext();
  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted() {
      refetch({ variables: { id: userData.id } });
    },
  });

  const [isLoading, setIsLoading] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);

  const { formValues, setFormValues, register, unregister, setValue } = useFormHook();
  const RegisterFormProps = { register, unregister, setValue, formValues };

  const BaseRequiredProps = {
    errorMessage: "Dies ist ein Pflichtfeld",
    required: true,
    ...RegisterFormProps,
  };

  useEffect(() => {
    if (!userData) return;
    setIsLoading(true);
    setFormValues({
      office: userData.office,
      firstName: userData.firstName,
      lastName: userData.lastName,
      phone: userData.phone,
      street: userData.street,
      zip: userData.zip,
      city: userData.city,
      country: userData.country,
    });
    setIsLoading(false);
  }, [userData]);

  if (isLoading)
    return <div className="w-8 h-8 ease-linear border-2 border-t-2 border-gray-200 rounded-full loader"></div>;
  return (
    <div className="mb-6 overflow-hidden bg-white rounded shadow-md">
      <div className="px-6 py-4">
        <div className="mb-2 text-xl font-bold">Kontoeinstellungen</div>
        <form
          onChange={(e) => {
            if (showSuccess) setShowSuccess(false);
          }}
          onSubmit={async (e) => {
            e.preventDefault();
            const data = dot.object(formValues);
            await updateUser({ variables: { id: userData.id, verified: false, ...data } });
            setShowSuccess(true);
          }}
        >
          <Input value={formValues.office} id="office" label="Praxisname" {...BaseRequiredProps} />
          <div className="flex flex-wrap -mx-4">
            <Input
              className="w-1/2 px-4"
              value={formValues.firstName}
              id="firstName"
              label="Vorname"
              {...BaseRequiredProps}
            />
            <Input
              className="w-1/2 px-4"
              value={formValues.lastName}
              id="lastName"
              label="Nachname"
              {...BaseRequiredProps}
            />

            <Input className="w-1/2 px-4" value={formValues.phone} id="phone" label="Telefon" {...BaseRequiredProps} />
            <Input
              className="w-1/2 px-4"
              value={formValues.street}
              id="street"
              label="Straße und Hausnummer"
              {...BaseRequiredProps}
            />
            <Input className="w-1/2 px-4" value={formValues.zip} id="zip" label="Postleitzahl" {...BaseRequiredProps} />
            <Input className="w-1/2 px-4" value={formValues.city} id="city" label="Stadt" {...BaseRequiredProps} />
            <Select
              className="w-1/2 px-4"
              options={[
                { label: "Deutschland", value: "DE" },
                { label: "Österreich", value: "AT" },
                { label: "Schweiz", value: "CH" },
                { label: "Liechtenstein", value: "LI" },
                { label: "Italien", value: "IT" },
              ]}
              value={formValues.country}
              id="country"
              label="Land"
              placeholder="Land auswählen"
              {...BaseRequiredProps}
            />
          </div>
          <Button type="submit">Kontodaten aktualisieren</Button>
          {showSuccess && <p className="mt-2 text-gray-700">Deine Kontodaten wurden erfolgreich aktualisiert</p>}
        </form>
      </div>
    </div>
  );
}
